import { useContext, useEffect, useState } from "react";
import {
  PersonBankAccountViewModel,
  PersonTaxRateAndBalance,
} from "../../../generated/data-contracts";
import { IAxiosError, api } from "../../../utils";
import { AvisForm } from "../../shared/components";
import {
  AvisDescriptiveText,
  AvisSection,
  AvisValueRow,
} from "../../shared/components/form";
import { AvisContext } from "../../shared/context/AvisContext";
import { ErrorLoadingDataHoc } from "../../shared/error/ErrorLoadingDataHoc";
import { BillingDataGrid } from "./BillingDataGrid";

export function BillingDataPage() {
  const { res } = useContext(AvisContext);
  const [initGridData, setInitGridData] = useState<
    PersonBankAccountViewModel[] | undefined
  >();
  const [billingData, setBillingData] = useState<
    PersonTaxRateAndBalance | undefined
  >();
  const [isBillingDataLoading, setIsBillingDataLoading] =
    useState<boolean>(true);
  const [isGridLoading, setIsGridLoading] = useState<boolean>(true);
  const [dataLoadingError, setDataLoadingError] = useState<IAxiosError>();
  const [gridLoadingError, setGridLoadingError] = useState<IAxiosError>();

  const getData = () => {
    if (!isBillingDataLoading) setIsBillingDataLoading(true);

    api
      .rightsHoldersGetPersonTaxAndBalanceInfo()
      .then((res) => setBillingData(res.data))
      .catch(setDataLoadingError)
      .finally(() => setIsBillingDataLoading(false));
  };

  const getGridData = () => {
    if (!isGridLoading) setIsGridLoading(true);

    api
      .rightsHoldersGetPersonBankAccounts()
      .then((res) => setInitGridData(res.data))
      .catch(setGridLoadingError)
      .finally(() => setIsGridLoading(false));
  };

  useEffect(() => {
    getData();
    getGridData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderPage = () => {
    return (
      <>
        <AvisSection
          title={res("authors_BillingDataPage_Section_BalanceTitle")}
        >
          <ErrorLoadingDataHoc
            error={dataLoadingError}
            loading={isBillingDataLoading}
          >
            <AvisDescriptiveText textKey="portal_RH_BillingData_1" />
            <AvisValueRow
              className="balance-info"
              rowTitle={res("authors_BillingDataPage_Section_BalanceInfoLabel")}
              rowValue={
                billingData?.balance !== undefined &&
                billingData.balance !== null
                  ? res("value_format_Eur", billingData.balance.toFixed(2))
                  : res("message_NoData")
              }
            />
          </ErrorLoadingDataHoc>
        </AvisSection>
        <AvisSection title={res("authors_BillingDataPage_Section_TaxTitle")}>
          <ErrorLoadingDataHoc
            error={dataLoadingError}
            loading={isBillingDataLoading}
          >
            <AvisDescriptiveText textKey="portal_RH_BillingData_2" />
            <AvisValueRow
              rowTitle={billingData?.taxName}
              rowValue={
                billingData?.rate !== undefined && billingData.rate !== null
                  ? res(
                      "value_format_Percentage",
                      Number(billingData.rate.toFixed(2)).toString(),
                    )
                  : res("message_NoData")
              }
            />
          </ErrorLoadingDataHoc>
        </AvisSection>
        <BillingDataGrid
          initGridData={initGridData}
          error={gridLoadingError}
          isGridLoading={isGridLoading}
        />
      </>
    );
  };

  return (
    <AvisForm
      title={res("authors_BillingDataPage_Title")}
      className="billing-data"
    >
      {renderPage()}
    </AvisForm>
  );
}
